<template>
    <div class="main-loader">
        <img :src="publicPath + 'images/loading-' + type + '.gif'" :alt="text">
    </div>
</template>

<script>
    import {publicPath} from "../main";

    export default {
        name: "Loading",
        props: {
            text: {
                type: String,
                default: 'Načítavam...'
            },
            type: {
                type: String,
                default: 'white'
            }
        },
        data() {
            return {
                publicPath: publicPath
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-loader {
        width: 100%;
        text-align: center;

        img {
            max-height: 60px;
        }
    }
</style>